import { call, put, takeLatest } from 'redux-saga/effects'
import { AdminFetchUsBankEarningOrders, AdminFetchUsBankEarnings } from 'src/constants/actionTypes'
import { Endpoints } from 'src/constants/endpoints'
import type {
  FetchUsBankEarningOrdersPayload,
  FetchUsBankEarningsPayload,
  UsBankEarningOrder,
  UsBankEarningsPage,
} from 'src/interfaces/usBankTransactions'
import { buildUsBankEarningsQuery } from 'src/utils/paymentsOps/usBankEarnings'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { captureSentryError } from 'src/utils/sentry'
import type { AsyncAction } from 'src/utils/reduxUtils'
import { callSecureApi } from './api/callApi'

export function* onFetchUsBankEarnings(action: AsyncAction<FetchUsBankEarningsPayload>) {
  try {
    const { payload }: { payload: UsBankEarningsPage } = yield call(
      callSecureApi,
      Endpoints.AdminFetchUsBankEarnings,
      { method: 'GET', query: buildUsBankEarningsQuery(action.payload) },
    )

    yield put(AdminFetchUsBankEarnings.success(payload))

    if (action.next) {
      action.next(null, payload)
    }
  } catch (error: unknown) {
    captureSentryError(error, { message: '[saga.usBankTransactions.onFetchUsBankEarnings] error' })

    yield put(AdminFetchUsBankEarnings.failed(error))

    if (action.next) {
      action.next(resolveErrorMessage(error, 'Failed to load US Bank transactions'))
    }
  }
}

export function* onFetchUsBankEarningOrders(action: AsyncAction<FetchUsBankEarningOrdersPayload>) {
  try {
    const { payload }: { payload: { data: UsBankEarningOrder[] } } = yield call(
      callSecureApi,
      Endpoints.AdminFetchUsBankEarningOrders,
      {
        method: 'GET',
        params: [{ field: ':earningId', value: action.payload.earningId }],
      },
    )

    const orders = payload?.data ?? []

    yield put(AdminFetchUsBankEarningOrders.success(orders))

    if (action.next) {
      action.next(null, orders)
    }
  } catch (error: unknown) {
    captureSentryError(error, {
      message: '[saga.usBankTransactions.onFetchUsBankEarningOrders] error',
    })

    yield put(AdminFetchUsBankEarningOrders.failed(error))

    if (action.next) {
      action.next(resolveErrorMessage(error, 'Failed to load orders'))
    }
  }
}

export function* usBankTransactionsSaga() {
  yield takeLatest(AdminFetchUsBankEarnings.type.REQUEST, onFetchUsBankEarnings)
  yield takeLatest(AdminFetchUsBankEarningOrders.type.REQUEST, onFetchUsBankEarningOrders)
}
